
import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import { BgDialog } from "@banggood/scm-fe";
import EncasementForm from "./form.vue";
import {
  transformCreateDataItemToPONItem,
  transformViewDataItemToPONItem,
} from "./utils";
import { PONItem, CreateDataItem } from "./definitions";
import {
  saveBatch,
  SaveBatchRequest,
  QueryByArrivalItemIdsResponse,
} from "@/service/yttCodegen/ewold/api/arrivalItemPackingInfo";
@Component({
  components: {
    BgDialog,
    EncasementForm,
  },
})
export default class EncasementDialog extends Vue {
  @Ref("encasementForm") encasementForm!: EncasementForm;
  @Prop() visible!: boolean;
  @Prop({ required: false, default: "create" }) mode!:
    | "create"
    | "modify"
    | "view";
  /** 新增时使用的数据 */
  @Prop() createData?: CreateDataItem[];
  /** 编辑时使用的数据*/
  @Prop() modifyData?: any;
  /** 查看详情时使用的数据*/
  @Prop() viewData?: any;
  submitting = false;
  renderFormTask: null | (() => void) = null;
  get editable() {
    return ["create", "modify"].includes(this.mode);
  }
  mounted() {
    this.renderForm();
  }
  handleOpened() {
    if (this.encasementForm) {
      if (this.renderFormTask) {
        this.renderFormTask();
        this.renderFormTask = null;
      } else {
        this.renderForm();
      }
    }
  }
  renderForm() {
    const renderFn = () => {
      if (this.mode === "create" && Array.isArray(this.createData)) {
        this.encasementForm.setFormData(
          this.createData.map(transformCreateDataItemToPONItem)
        );
      } else if (this.mode === "modify" && this.modifyData) {
        this.encasementForm.setFormData([]);
      } else if (this.mode === "view" && this.viewData) {
        this.encasementForm.setFormData(
          this.viewData.map(transformViewDataItemToPONItem)
        );
      }
    };
    if (this.encasementForm) {
      renderFn();
    } else {
      this.renderFormTask = renderFn;
    }
  }
  async submit() {
    const valid = await this.encasementForm.validate();
    if (!valid) {
      this.encasementForm.scrollErrorIntoView();
      return;
    }
    if (this.mode === "create") {
      this.createSubmit();
    } else if (this.mode === "modify") {
      this.modifySubmit();
    }
  }
  async createSubmit() {
    const fd = this.encasementForm.getFormData();
    const itemList: SaveBatchRequest = [];
    fd.forEach((ele) => {
      ele.cartonSizeList.forEach((cartonSize) => {
        itemList.push({
          arrival_item_id: ele.arrivalItemId,
          delivery_code: ele.deliveryCode,
          delivery_id: ele.deliveryId,
          delivery_item_id: ele.deliveryItemId,
          longest_side: String(cartonSize.length),
          second_long_side: String(cartonSize.width),
          shortest_side: String(cartonSize.height),
          num: cartonSize.quantity,
          num_of_boxes: Number(cartonSize.boxQuantity),
          num_of_single_box: Number(cartonSize.perBoxQuantity),
          outer_box_gross_weight: Number(cartonSize.outerBoxGrossWeight),
          outer_box_net_weight: Number(cartonSize.outerBoxNetWeight),
          package_code: ele.packageCode || "",
          product_code: cartonSize.productCode,
          product_id: cartonSize.productId,
          property_code: cartonSize.propertyCode || "",
          property_id: cartonSize.propertyId,
          purchase_order_code: ele.purchaseOrderCode,
        });
      });
    });
    this.submitting = true;
    const res = await saveBatch(itemList);
    if (res.is_success) {
      this.$message.success("装箱已提交");
      this.$emit("success");
    } else {
      this.submitting = false;
    }
  }
  async modifySubmit() {
    //
  }
  close() {
    this.$emit("update:visible", false);
    this.$emit("close");
  }
}
